/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { Box } from '../../';
import SkeletonBox from './SkeletonBox';
import useRandomSkeletonWidth from './useRandomSkeletonWidth';

/**
 * @param {object} props
 * @param {number} [props.lines] The number of lines.
 * @param {number} [props.offset] The offset for a staggered animation.
 * @param {string | number} [props.width]
 * @param {string | number} [props.height]
 * @param {string} [props.variant] The text variant, defined in textVariants.js.
 * @param {string} [props.className]
 */
export default function SkeletonText({
  width,
  lines = 1,
  offset = 0,
  height,
  variant = 'default',
  className,
}) {
  const [getWidth] = useRandomSkeletonWidth(lines, { width });

  return (
    <Box className={className}>
      {Array(lines)
        .fill(null)
        .map((_, line) => (
          <SkeletonBox
            key={line}
            as="p"
            offset={offset}
            width={getWidth(line)}
            height={height}
            sx={{
              variant: `text.${variant}`,
              transform: 'scaleY(0.7)',
            }}
          />
        ))}
    </Box>
  );
}
